export default __webpack_public_path__ + "static/media/blank-logo.cdf50521.png";